export enum CommonActionType {
  FETCH_ORDER_STATUS_LIST = 'FETCH_ORDER_STATUS_LIST',
}
